"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockGatewayVersion = exports.gte = exports.gt = exports.eq = exports.lt = exports.lte = exports.useGatewayVersion = void 0;
const react_1 = require("react");
const client_1 = require("@apollo/client");
function useGatewayVersion(locationId) {
    var _a;
    const { data, loading, error } = client_1.useQuery(GATEWAY_VERSION_QUERY, {
        context: {
            locationId,
        },
    });
    const version = (_a = data === null || data === void 0 ? void 0 : data.version) !== null && _a !== void 0 ? _a : undefined;
    const { error: internalError, semver } = react_1.useMemo(() => {
        if (!version) {
            return { error: undefined, semver: undefined };
        }
        try {
            return { error: undefined, semver: extractSemver(version) };
        }
        catch (_a) {
            return { error: new Error('Could not extract version number.'), semver: undefined };
        }
    }, [version]);
    return {
        loading,
        error: error !== null && error !== void 0 ? error : internalError,
        version,
        eq: useComparison(eq, semver),
        lt: useComparison(lt, semver),
        gt: useComparison(gt, semver),
        lte: useComparison(lte, semver),
        gte: useComparison(gte, semver),
    };
}
exports.useGatewayVersion = useGatewayVersion;
function useComparison(comp, a) {
    return react_1.useCallback(function (major, minor, patch, defaultValue) {
        return a ? comp(a, { major, minor, patch }) : defaultValue;
    }, [comp, a]);
}
function extractSemver(version) {
    var _a, _b, _c;
    const parts = version.match(/^Fiona R(\d+)\.(\d+)\.(\d+).*? r\d+\.\d+\.\d+.*?$/);
    if (!parts) {
        throw new Error("Couldn't parse version string.");
    }
    const major = (_a = parts[1]) !== null && _a !== void 0 ? _a : undefined;
    const minor = (_b = parts[2]) !== null && _b !== void 0 ? _b : undefined;
    const patch = (_c = parts[3]) !== null && _c !== void 0 ? _c : undefined;
    if (major === undefined || minor === undefined || patch === undefined) {
        throw new Error('Could not get version from version string.');
    }
    return {
        major: Number(major),
        minor: Number(minor),
        patch: Number(patch),
    };
}
function lte(a, b) {
    return lt(a, b) || eq(a, b);
}
exports.lte = lte;
function lt(a, b) {
    if (a.major < b.major) {
        return true;
    }
    else if (a.major > b.major) {
        return false;
    }
    else {
        if (a.minor < b.minor) {
            return true;
        }
        else if (a.minor > b.minor) {
            return false;
        }
        else {
            if (a.patch < b.patch) {
                return true;
            }
            else if (a.patch > b.patch) {
                return false;
            }
            else {
                return false;
            }
        }
    }
}
exports.lt = lt;
function eq(a, b) {
    return a.major === b.major && a.minor === b.minor && a.patch === b.patch;
}
exports.eq = eq;
function gt(a, b) {
    return lt(b, a);
}
exports.gt = gt;
function gte(a, b) {
    return gt(a, b) || eq(a, b);
}
exports.gte = gte;
function mockGatewayVersion(locationId, version) {
    if (!version.match(/^Fiona R\d+\.\d+\.\d+(.*?) r\d+\.\d+\.\d+(.*?)$/)) {
        throw new Error('Invalid version mocked. Must be on the format "Fiona R4.7.4 r4.7.4" or "Fiona R4.7.7LD1 r4.7.7LD1".');
    }
    return {
        request: {
            query: GATEWAY_VERSION_QUERY,
            context: {
                locationId,
            },
        },
        result: {
            data: {
                version,
            },
        },
    };
}
exports.mockGatewayVersion = mockGatewayVersion;
const GATEWAY_VERSION_QUERY = client_1.gql `
  query GatewayVersionQuery {
    version
  }
`;
//# sourceMappingURL=useGatewayVersion.js.map